// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var ix = /* #__PURE__ */ Foreign_Index.ix(/* #__PURE__ */ Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(/* #__PURE__ */ Foreign_Index.indexString(Data_Identity.monadIdentity));
var readInt = /* #__PURE__ */ Foreign.readInt(Data_Identity.monadIdentity);
var readString = /* #__PURE__ */ Foreign.readString(Data_Identity.monadIdentity);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var MethodNotFound = /* #__PURE__ */ (function () {
    function MethodNotFound(value0) {
        this.value0 = value0;
    };
    MethodNotFound.create = function (value0) {
        return new MethodNotFound(value0);
    };
    return MethodNotFound;
})();
var InvalidParams = /* #__PURE__ */ (function () {
    function InvalidParams(value0) {
        this.value0 = value0;
    };
    InvalidParams.create = function (value0) {
        return new InvalidParams(value0);
    };
    return InvalidParams;
})();
var OtherError = /* #__PURE__ */ (function () {
    function OtherError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    OtherError.create = function (value0) {
        return function (value1) {
            return new OtherError(value0, value1);
        };
    };
    return OtherError;
})();
var showRpcError = {
    show: function (v) {
        if (v instanceof MethodNotFound) {
            return "RPC Error: method not found. " + v.value0;
        };
        if (v instanceof InvalidParams) {
            return "RPC Error: invalid params sent to the server. " + v.value0;
        };
        if (v instanceof OtherError) {
            return "RPC Error " + (show(v.value0) + (": " + v.value1));
        };
        throw new Error("Failed pattern match at Network.RPCError (line 15, column 1 - line 18, column 72): " + [ v.constructor.name ]);
    }
};
var eqRPCError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof MethodNotFound && y instanceof MethodNotFound) {
                return x.value0 === y.value0;
            };
            if (x instanceof InvalidParams && y instanceof InvalidParams) {
                return x.value0 === y.value0;
            };
            if (x instanceof OtherError && y instanceof OtherError) {
                return x.value0 === y.value0 && x.value1 === y.value1;
            };
            return false;
        };
    }
};
var decodeRPCError = {
    decode: function (value) {
        return bind(bind(ix(value)("code"))(readInt))(function (code) {
            return bind(bind(ix(value)("message"))(readString))(function (message) {
                return pure((function () {
                    if (code === -32601) {
                        return new MethodNotFound(message);
                    };
                    if (code === -32602) {
                        return new InvalidParams(message);
                    };
                    return new OtherError(code, message);
                })());
            });
        });
    }
};
export {
    MethodNotFound,
    InvalidParams,
    OtherError,
    showRpcError,
    eqRPCError,
    decodeRPCError
};
